"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.injectToStepsForm = exports.injectToForm = exports.injectToBaseRegisterContainer = exports.injectToBaseCreationSteps = exports.injectToBaseCreationDialog = exports.injectToBaseContainer = void 0;
var _formik = require("formik");
var _react = _interopRequireDefault(require("react"));
var _BaseContainer = _interopRequireDefault(require("./BaseContainer"));
var _BaseCreationDialog = _interopRequireDefault(require("./BaseCreationDialog"));
var _BaseRegisterContainer = _interopRequireDefault(require("./BaseRegisterContainer"));
var _BaseCreationSteps = _interopRequireDefault(require("./BaseCreationSteps"));
var _reactIntl = require("react-intl");
var _excluded = ["formExtraFields", "handleInitialValues"],
  _excluded2 = ["formExtraFields", "handleInitialValues"],
  _excluded3 = ["props"],
  _excluded4 = ["props"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * This HOC is used to serve the option to the component as props
 * @param {React Component} Component - the form component to inject to
 * @param {object} options - the options that will be injected as props to the component
 *
 */
var injectToForm = function injectToForm(Component, options) {
  var EnhancedForm = /*#__PURE__*/function (_React$Component) {
    _inherits(EnhancedForm, _React$Component);
    var _super = _createSuper(EnhancedForm);
    function EnhancedForm(props) {
      var _this;
      _classCallCheck(this, EnhancedForm);
      _this = _super.call(this, props);
      _defineProperty(_assertThisInitialized(_this), "handleExtraFields", function (propsExtraFields, optionsExtraFields) {
        var extraFields = [];
        if (propsExtraFields && optionsExtraFields && _this.props.embedFieldsWithIndex) {
          optionsExtraFields(_this.props).forEach(function (item, index) {
            if (index === _this.props.embedFieldsWithIndex) {
              var _extraFields;
              (_extraFields = extraFields).push.apply(_extraFields, _toConsumableArray(propsExtraFields(_this.props)));
              extraFields.push(item);
            } else {
              extraFields.push(item);
            }
          });
        }
        if (propsExtraFields && optionsExtraFields && !_this.props.embedFieldsWithIndex) {
          extraFields = [].concat(_toConsumableArray(optionsExtraFields(_this.props)), _toConsumableArray(propsExtraFields(_this.props)));
        }
        if (propsExtraFields && !optionsExtraFields) {
          extraFields = _toConsumableArray(propsExtraFields(_this.props));
        }
        if (!propsExtraFields && optionsExtraFields) {
          extraFields = _toConsumableArray(optionsExtraFields(_this.props));
        }
        return function () {
          return extraFields;
        };
      });
      _defineProperty(_assertThisInitialized(_this), "handleStepsExtraFields", function (activeStep, propsSteps, optionsSteps) {
        var extraFields = [];
        var getStep = function getStep(steps, ignoreActiveStep) {
          if (ignoreActiveStep) {
            return steps(_this.props).length > 0 ? [steps(_this.props)[0]] : [];
          }
          return steps(_this.props).length > 0 ? [steps(_this.props)[activeStep]] : [];
        };

        // This part needs to be looked ar further
        if (propsSteps && optionsSteps && _this.props.embedFieldsWithIndex) {
          optionsSteps(_this.props).forEach(function (item, index) {
            if (index === _this.props.embedFieldsWithIndex) {
              var _extraFields2;
              (_extraFields2 = extraFields).push.apply(_extraFields2, _toConsumableArray(propsSteps(_this.props)));
              extraFields.push(item);
            } else {
              extraFields.push(item);
            }
          });
        }
        if (propsSteps && optionsSteps && !_this.props.embedFieldsWithIndex) {
          extraFields = [].concat(_toConsumableArray(getStep(optionsSteps)), _toConsumableArray(getStep(propsSteps, true)));
        }
        if (propsSteps && typeof _this.props.overrideStep === 'number' && _this.props.overrideStep === activeStep) {
          extraFields = _toConsumableArray(getStep(propsSteps, true));
        }
        if (propsSteps && !optionsSteps) {
          extraFields = _toConsumableArray(getStep(propsSteps));
        }
        if (!propsSteps && optionsSteps) {
          extraFields = _toConsumableArray(getStep(optionsSteps));
        }
        return function () {
          return extraFields;
        };
      });
      return _this;
    }
    _createClass(EnhancedForm, [{
      key: "render",
      value: function render() {
        var _this2 = this;
        // Use object destructering to seperate some keys from the original objects
        var optionsExtraFields = options.formExtraFields,
          optionsInitialValue = options.handleInitialValues,
          origOptions = _objectWithoutProperties(options, _excluded);
        var _this$props = this.props,
          propsExtraFields = _this$props.formExtraFields,
          propsInitialValue = _this$props.handleInitialValues,
          origProps = _objectWithoutProperties(_this$props, _excluded2);

        // Check if the component already have extraFields in it's props, if so merge them with the extraFields
        // from the options, or return the available propsExtraFields or optionsExtraFields
        var extraFields = origOptions.useSteps ? this.handleStepsExtraFields(this.props.activeStep, propsExtraFields, optionsExtraFields) : this.handleExtraFields(propsExtraFields, optionsExtraFields);

        // Check if the component already have initialValues in it's props, if so merge them with the initialValues
        // from the options, or return the available propsInitialValue or optionsInitialValue
        var initialValues = propsInitialValue && optionsInitialValue ? function () {
          return _objectSpread(_objectSpread({}, optionsInitialValue(_this2.props)), propsInitialValue(_this2.props));
        } : propsInitialValue && !optionsInitialValue ? function () {
          return _objectSpread({}, propsInitialValue(_this2.props));
        } : !propsInitialValue && optionsInitialValue ? function () {
          return _objectSpread({}, optionsInitialValue(_this2.props));
        } : function () {
          return {};
        };
        return /*#__PURE__*/_react.default.createElement(Component, _extends({
          formExtraFields: extraFields,
          handleInitialValues: initialValues
        }, origProps, origOptions));
      }
    }]);
    return EnhancedForm;
  }(_react.default.Component); // Wrap our form component using withFormik
  return (0, _formik.withFormik)({
    // In order to have initialValues, we need to handle the function handleInitialValues to provide all
    // initialValues either from props or option or both.
    // NOTE: initialValues are needed because we want our form to show the errors when submiting
    mapPropsToValues: function mapPropsToValues(props) {
      return props.handleInitialValues && options.handleInitialValues ? _objectSpread(_objectSpread({}, props.handleInitialValues(props)), options.handleInitialValues(props)) : props.handleInitialValues && !options.handleInitialValues ? props.handleInitialValues(props) : !props.handleInitialValues && options.handleInitialValues ? options.handleInitialValues(props) : {};
    },
    handleSubmit: function handleSubmit(values, _ref) {
      var props = _ref.props,
        meta = _objectWithoutProperties(_ref, _excluded3);
      // If the form is extending an other form we need to pass the values
      // from the parent form to the child form, because the changes to the fields
      // are made to the fields of the parent
      // isFormExtended needs to be set in the option of the extending form (child)
      if (props.isFormExtended) {
        props.setValues(_objectSpread({}, values));
        props.handleSubmit(values, meta);
      } else {
        props.handleSubmit(values, meta);
      }
    },
    handleInputChange: function handleInputChange(props) {
      return props.handleInputChange;
    },
    handleSelectChange: function handleSelectChange(props) {
      return props.handleSelectChange;
    },
    enableReinitialize: function enableReinitialize(props) {
      return props.enableReinitialize ? true : false;
    },
    displayName: "BasicForm"
  })((0, _reactIntl.injectIntl)(EnhancedForm));
};

/**
 * This function will be used to inject the props provided from our wrapper and to inject the params
 * @param {function} wrapper - a function that invokes the given functions from right to left.
 * @param {object} params - object that contains the params that will be passed as props
 * NOTE: use flowRight from lodash to create the wrapper
 */
exports.injectToForm = injectToForm;
var injectToBaseContainer = function injectToBaseContainer(wrapper, params) {
  return wrapper( /*#__PURE__*/function (_React$Component2) {
    _inherits(_class, _React$Component2);
    var _super2 = _createSuper(_class);
    function _class(props) {
      _classCallCheck(this, _class);
      return _super2.call(this, props);
    }
    _createClass(_class, [{
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react.default.createElement(_BaseContainer.default, _extends({}, this.props, params));
      }
    }]);
    return _class;
  }(_react.default.Component));
};

/**
 * This function will be used to inject the props provided from our wrapper and to inject the params
 * @param {function} wrapper - a function that invokes the given functions from right to left.
 * @param {object} params - object that contains the params that will be passed as props
 * NOTE: use flowRight from lodash to create the wrapper
 */
exports.injectToBaseContainer = injectToBaseContainer;
var injectToBaseCreationDialog = function injectToBaseCreationDialog(wrapper, params) {
  return wrapper( /*#__PURE__*/function (_React$Component3) {
    _inherits(Enhancer, _React$Component3);
    var _super3 = _createSuper(Enhancer);
    function Enhancer(props) {
      _classCallCheck(this, Enhancer);
      return _super3.call(this, props);
    }
    _createClass(Enhancer, [{
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react.default.createElement(_BaseCreationDialog.default, _extends({}, this.props, params));
      }
    }]);
    return Enhancer;
  }(_react.default.Component));
};
exports.injectToBaseCreationDialog = injectToBaseCreationDialog;
var injectToBaseRegisterContainer = function injectToBaseRegisterContainer(wrapper, params) {
  return wrapper( /*#__PURE__*/function (_React$Component4) {
    _inherits(Enhancer, _React$Component4);
    var _super4 = _createSuper(Enhancer);
    function Enhancer(props) {
      _classCallCheck(this, Enhancer);
      return _super4.call(this, props);
    }
    _createClass(Enhancer, [{
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react.default.createElement(_BaseRegisterContainer.default, _extends({}, this.props, params));
      }
    }]);
    return Enhancer;
  }(_react.default.Component));
};
exports.injectToBaseRegisterContainer = injectToBaseRegisterContainer;
var injectToStepsForm = function injectToStepsForm(Component, options) {
  var EnhancedForm = /*#__PURE__*/function (_React$Component5) {
    _inherits(EnhancedForm, _React$Component5);
    var _super5 = _createSuper(EnhancedForm);
    function EnhancedForm(props) {
      _classCallCheck(this, EnhancedForm);
      return _super5.call(this, props);
    }
    _createClass(EnhancedForm, [{
      key: "render",
      value: function render() {
        var handleInitialValues = options.handleInitialValues;

        // const { handleInitialValues } = this.props

        return /*#__PURE__*/_react.default.createElement(Component, _extends({
          steps: options.steps,
          handleInitialValues: handleInitialValues
        }, this.props));
      }
    }]);
    return EnhancedForm;
  }(_react.default.Component);
  return (0, _formik.withFormik)({
    mapPropsToValues: function mapPropsToValues(props) {
      return props.handleInitialValues && options.handleInitialValues ? _objectSpread(_objectSpread({}, props.handleInitialValues(props)), options.handleInitialValues(props)) : props.handleInitialValues && !options.handleInitialValues ? props.handleInitialValues(props) : !props.handleInitialValues && options.handleInitialValues ? options.handleInitialValues(props) : {};
    },
    handleSubmit: function handleSubmit(values, _ref2) {
      var props = _ref2.props,
        meta = _objectWithoutProperties(_ref2, _excluded4);
      if (props.isFormExtended) {
        props.setValues(_objectSpread({}, values));
        props.handleSubmit(values, meta);
      } else {
        props.handleSubmit(values, meta);
      }
    },
    handleInputChange: function handleInputChange(props) {
      return props.handleInputChange;
    },
    handleSelectChange: function handleSelectChange(props) {
      return props.handleSelectChange;
    },
    displayName: "BasicForm"
  })(EnhancedForm);
};
exports.injectToStepsForm = injectToStepsForm;
var injectToBaseCreationSteps = function injectToBaseCreationSteps(wrapper, params) {
  return wrapper( /*#__PURE__*/function (_React$Component6) {
    _inherits(Enhancer, _React$Component6);
    var _super6 = _createSuper(Enhancer);
    function Enhancer(props) {
      _classCallCheck(this, Enhancer);
      return _super6.call(this, props);
    }
    _createClass(Enhancer, [{
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react.default.createElement(_BaseCreationSteps.default, _extends({}, this.props, params));
      }
    }]);
    return Enhancer;
  }(_react.default.Component));
};
exports.injectToBaseCreationSteps = injectToBaseCreationSteps;